import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {EmployeeRoleEnum} from '../models/employee/employee-role.enum';
import {EnumOpportunityType} from '../models/enum/enum-opportunity-type';
import {QuoteWrapper} from '../models/quote/quote-wrapper';
import {EQuoteMode, StandaloneModeService} from '../standalone-mode.service';

@Injectable({
    providedIn: 'root',
})
export class EppRouterService {

    constructor(private readonly router: Router,
        private readonly standaloneModeService: StandaloneModeService) {
    }

    private static convertRoleCode(employeeRole: EmployeeRoleEnum): string {
        switch (employeeRole.eForceRole) {
            case EmployeeRoleEnum.CA_ICS_HBE.eForceRole:
                return 'ca-ics-hbe';
            case EmployeeRoleEnum.CA_ICS_VT.eForceRole:
                return 'ca-ics-vt';
            case EmployeeRoleEnum.AC.eForceRole:
            case EmployeeRoleEnum.CRV_PRO.eForceRole:
                return 'ac';
            case EmployeeRoleEnum.CC.eForceRole:
            case EmployeeRoleEnum.CCL.eForceRole:
            case EmployeeRoleEnum.CSC.eForceRole:
            case EmployeeRoleEnum.ASC.eForceRole:
            case EmployeeRoleEnum.CSL.eForceRole:
            case EmployeeRoleEnum.DC.eForceRole:
                return 'disco';
            default:
                return '404';
        }
    }

    public redirectToUrl(url :string): void {
        this.router.navigate([url]);
    }

    public redirectToMyOpportunities(): void {
        switch (this.standaloneModeService.eQuoteMode) {
            case EQuoteMode.CRM_LINKED_AND_OFFLINE:
                this.router.navigate([`/standalone/opportunity-history`]);
                return;
            case EQuoteMode.CRM_NOT_LINKED_AND_OFFLINE:
                this.router.navigate([`/offline-equote-opportunities`]);
                return;
            case EQuoteMode.CRM_NOT_LINKED_AND_ONLINE:
                this.router.navigate([`/opportunity-history`]);
                return;
            default:
                throw new Error('Invalid eQuote mode for redirecting to opportunities');
        }
    }

    public redirectToMyStandaloneQuotes(): void {
       this.router.navigate([`/standalone-quote-history`]);
    }

    public redirectToQuoteType(readOnlyMode: boolean): void {
        this.router.navigate([`/quote-type`], readOnlyMode ? {queryParams : {readOnlyMode}} : {});
    }

    public redirectToSynthesis(readOnlyMode: boolean, employeeRole: EmployeeRoleEnum, opportunityType: EnumOpportunityType) {
        this.router.navigate([`/${EppRouterService.convertRoleCode(employeeRole)}/${opportunityType.toLowerCase()}/synthesis`], readOnlyMode ? {queryParams : {readOnlyMode}} : {});
    }

    redirectToQuoteCreation(readOnlyMode: boolean, employeeRole: EmployeeRoleEnum, opportunityType: EnumOpportunityType) {
        this.router.navigate([`/${EppRouterService.convertRoleCode(employeeRole)}/${opportunityType.toLowerCase()}/quote-creation`], readOnlyMode ? {queryParams : {readOnlyMode}} : {});
    }

    redirectToOpportunityContext(url: string): void {
        this.router.navigateByUrl(url);
    }

    public redirectToViewQuote(quoteId: string): void {
        this.router.navigate([`/view-quote`], {queryParams : {id: quoteId} });
    }

    public getCurrentUrl():string {
        return this.router.url;
    }

    redirectAfterQuoteCompletion(createdQuoteId: string) {
        if (this.standaloneModeService.eQuoteMode === EQuoteMode.CRM_LINKED_AND_ONLINE) {
            this.redirectToViewQuote(createdQuoteId);
        } else if (this.standaloneModeService.eQuoteMode === EQuoteMode.CRM_LINKED_AND_OFFLINE) {
            this.redirectToMyStandaloneQuotes();
        } else {
            this.redirectToMyOpportunities();
        }
    }

    redirectToAppropriatePageAfterConsultingQuote(): void {
        if(this.standaloneModeService.eQuoteMode === EQuoteMode.CRM_LINKED_AND_OFFLINE){
            this.redirectToMyStandaloneQuotes();
        } else {
            this.redirectToMyOpportunities();
        }
    }

}
